<template>
	<div class="row h-100 align-items-center">
		<div class="col-12 col-lg-6 d-none d-lg-block">
			<img
				src="@/application/assets/images/add_business.png"
				class="img-fluid mx-auto p-4"
			>
		</div>
		<div class="col-12 col-lg-6">
			<h2>Crea una nueva empresa</h2>
			<p class="w-75 w-75 text-justify mb-5">
				Para poder gestionar cualquier acción con una empresa primero debes darla de alta.
				Introduce los campos que ves a continuación para poder proceder.
			</p>
			<validation-observer v-slot="{ passes, invalid }">
				<form @submit.prevent="passes(save)">
					<div class="row mb-4">
						<div class="col-12 col-sm-6">
							<g-field
								v-model="fields.EmpresaNombre"
								:disabled="loading"
								:app="app"
								:item="0"
								name="EmpresaNombre"
								placeholder=""
								title="Razón Social"
							/>
						</div>
						<div class="col-12 col-sm-6">
							<g-field
								v-model="fields.EmpresaCIF"
								:disabled="loading"
								:app="app"
								:item="0"
								name="EmpresaCIF"
								placeholder=""
								title="CIF/NIF/NIE"
							/>
						</div>
					</div>
					<a-divider dashed>
						<fa-icon
							icon="globe-europe"
							class="mr-2"
						/> Datos geográficos
					</a-divider>
					<div class="row mb-4">
						<div class="col-12">
							<label>Dirección</label>
							<vue-google-autocomplete
								id="map"
								ref="map"
								classname="form-control"
								placeholder=""
								:disabled="loading"
								@placechanged="inputPlace"
								@inputChange="inputChange"
								@change="inputChange2"
							/>
						</div>
					</div>
					<div class="row">
						<div class="col-12 col-sm-3">
							<g-field
								v-model="fields.EmpresaCP"
								:app="app"
								:item="0"
								name="EmpresaCP"
								placeholder=""
								title="Código Postal"
								:disabled="loading"
							/>
						</div>
						<div class="col-12 col-sm-3">
							<g-field
								v-model="fields.EmpresaLocalidad"
								:disabled="loading"
								:app="app"
								:item="0"
								name="EmpresaLocalidad"
								placeholder=""
								title="Localidad"
							/>
						</div>
						<div class="col-12 col-sm-3">
							<g-field
								v-model="fields.EmpresaProvincia"
								:disabled="loading"
								:app="app"
								:item="0"
								name="EmpresaProvincia"
								placeholder=""
								title="Provincia"
							/>
						</div>
						<div class="col-12 col-sm-3">
							<g-field
								v-model="fields.EmpresaPais"
								:disabled="loading"
								:app="app"
								:item="0"
								name="EmpresaPais"
								placeholder=""
								title="Pais"
							/>
						</div>
					</div>
					<a-divider dashed>
						<fa-icon
							icon="phone"
							class="mr-2"
						/> Datos de contacto
					</a-divider>
					<div class="row mb-5">
						<div class="col-12 col-sm-6">
							<g-field
								v-model="fields.EmpresaTelefono"
								:disabled="loading"
								:app="app"
								:item="0"
								name="EmpresaTelefono"
								placeholder=""
								title="Teléfono"
							/>
						</div>
						<div class="col-12 col-sm-6">
							<g-field
								v-model="fields.EmpresaEmail"
								:disabled="loading"
								:app="app"
								:item="0"
								name="EmpresaEmail"
								placeholder=""
								title="Email"
							/>
						</div>
					</div>
					<div class="row">
						<div class="col-12 text-right">
							<a-popconfirm
								title="¿Estas seguro que deseas limpiar todo el formulario?"
								@confirm="() => reset()"
							>
								<a-button
									type="danger"
									class="mr-2"
									:disabled="loading"
								>
									<fa-icon
										:icon="['fas','broom']"
										class="mr-2"
									/> <b>LIMPIAR</b>
								</a-button>
							</a-popconfirm>
							<a-button
								type="primary"
								html-type="submit"
								:disabled="invalid"
								:loading="loading"
							>
								<fa-icon
									:icon="['far','plus-square']"
									class="mr-2"
								/> <b>CREAR</b>
							</a-button>
						</div>
					</div>
				</form>
			</validation-observer>
		</div>
	</div>
</template>

<script>

import VueGoogleAutocomplete from 'vue-google-autocomplete';

export default {
	name: 'EmpresaNew',
	components: { VueGoogleAutocomplete },
	data() {
		return {
			app: 'empresas',
			loading: false,
			fields: {
				EmpresaNombre: '',
				EmpresaCIF: '',
				EmpresaDomicilioSocial: '',
				EmpresaCP: '',
				EmpresaLocalidad: '',
				EmpresaProvincia: '',
				EmpresaPais: '',
				EmpresaTelefono: '',
				EmpresaEmail: ''
			}
		};
	},

	methods: {
		async save() {
			this.loading = true;

			const params = this.fields;
			params.EmpresaEstado = 0;
			params.EmpresaNombreComercial = params.EmpresaNombre;

			const data = await this.$gestios.items('empresas').add({ params, view: this.view });

			this.loading = false;

			if (data.ok) this.$router.push({ name: 'empresas' });
		},
		reset() {
			this.fields = {
				EmpresaNombre: '',
				EmpresaCIF: '',
				EmpresaDomicilioSocial: '',
				EmpresaCP: '',
				EmpresaLocalidad: '',
				EmpresaProvincia: '',
				EmpresaPais: '',
				EmpresaTelefono: '',
				EmpresaEmail: ''
			};

			this.$refs.map.clear();
		},
		inputPlace(place) {
			if (place.administrative_area_level_1) {
				this.fields.EmpresaProvincia = place.administrative_area_level_1;
			}

			if (place.locality) this.fields.EmpresaLocalidad = place.locality;
			if (place.postal_code) this.fields.EmpresaCP = place.postal_code;
			if (place.country) this.fields.EmpresaPais = place.country;
		},
		inputChange(data) {
			this.fields.EmpresaDomicilioSocial = data.newVal;
		},
		inputChange2(data) {
			this.fields.EmpresaDomicilioSocial = data;
		}
	}
};
</script>

<style lang="scss">
	[data-kit-theme="default"] #map.form-control[disabled] {
		color: $gray-4;
		background-color: $gray-2;
		cursor: not-allowed;
		opacity: 1;
	}

	[data-kit-theme="dark"] #map.form-control[disabled] {
		color: #626293;
		background-color: #242243;
		cursor: not-allowed;
		opacity: 1;
	}

	[data-kit-theme="dark"] label {
		color: $dark-gray-1;
	}
</style>
